import VueRouter from "vue-router";
import Formulario from "./pages/CreateEmail.vue";
import Panel from "./pages/Dashboard.vue";
import Listas from "./pages/ListManager.vue";
import Ampliado from "./pages/EmailDetail.vue";
import Login from "./pages/Login.vue";
import Usuario from "./pages/UserManager.vue";
import Unsuscribe from "@/pages/Unsuscribe.vue";
import Blacklist from "@/pages/BlacklistManager.vue";
import Logs from "@/pages/Logs.vue";
import MessageList from "@/pages/MessageList.vue"
import Configurations from "@/pages/Configurations.vue";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/Login",
      name: "Login",
      component: Login,
      meta: {
        guest: true,
      },
    },
    {
      path: "/Usuario",
      component: Usuario,
      name: "Usuario",
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/unsuscribe/:secret/:email/:categoryId/:mailingId",
      component: Unsuscribe,
      name: "unsuscribe",
      meta: {
        requiresAuth: false,
      },
      props: { UI: false },
    },

    {
      path: "/",
      name: "Home",
      component: Panel,
      meta: {
        requiresAuth: true,
      },
      props: (route) => ({
        filtro_pais: route.query.fp,
        filtro_categoria: route.query.fc,
        filtro_estado: route.query.fe,
        filtro_lista: route.query.fl,
        filtro_periodo: route.query.fpe,
        filtro_textUTM: route.query.ft,
        filtro_order: route.query.order,
        filtro_dir: route.query.dir,
      }),
    },

    {
      path: "/messages",
      name: "Messages",
      component: MessageList,
      meta: {
        requiresAuth: true,
      },
      props: (route) => ({
        filtro_periodo: route.query.fpe,
        filtro_subject: route.query.ft,
        filtro_order: route.query.order,
        filtro_dir: route.query.dir,
        filtro_to: route.query.to,
        filtro_from: route.query.from,
      }),
    },
    {
      name: "Panel",
      path: "/panel/:tab",
      component: Panel,
      meta: {
        requiresAuth: true,
      },
      props: (route) => ({
        filtro_pais: route.query.fp,
        filtro_categoria: route.query.fc,
        filtro_estado: route.query.fe,
        filtro_lista: route.query.fl,
        filtro_periodo: route.query.fpe,
        filtro_textUTM: route.query.ft,
        filtro_order: route.query.order,
        filtro_dir: route.query.dir,
      }),
    },
    {
      path: "/email/nuevo",
      name: "crear",
      component: Formulario,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/email/actualizar/:idMail",
      name: "actualizar",
      component: Formulario,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: "/email/duplicar/:idMail",
      name: "duplicar",
      component: Formulario,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: "/email/reenviar/:idMail",
      name: "reenviar",
      component: Formulario,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: "/listas",
      name: "Listas",
      component: Listas,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/blacklist",
      name: "Blacklist",
      component: Blacklist,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ampliado/:idMail",
      name: "Ampliado",
      component: Ampliado,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: "/logs",
      name: "Logs",
      component: Logs,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
    {
      path: "/configurations",
      name: "Configurations",
      component: Configurations,
      meta: {
        requiresAuth: true,
      },
      props: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("md5") === null) {
      next({
        path: "/Login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      const rol = JSON.parse(localStorage.getItem("rol"));
      if (parseInt(rol) === 0 && to.name === "Usuario") {
        next({ name: "Panel" });
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("md5") === null) {
      next();
    } else {
      next({ name: "Home" });
    }
  } else {
    next();
  }
});

export default router;
